<template>
    <div>
      <v-dialog
        v-model="dialog"
        persistent
        scrollable
        max-width="900px"
      >
        <v-card>
          <v-toolbar
            flat
            color="blue-grey"
            dark
          >
            <v-toolbar-title>Tin nhắn</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="close"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </v-toolbar>
          <v-card-text class="mt-4">
            <v-data-table
              :headers="headers"
              :items="items"
              :expanded="expanded"
              item-key="id"
              show-expand
              :expanded.sync="expanded"
            >
              <template v-slot:item.data-table-expand="{ expand, isExpanded }">
                <v-icon @click="expand(!isExpanded)">mdi-eye{{isExpanded ? '-off' : ''}}</v-icon>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-simple-table style="background: transparent;">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Message</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ item.title }}</td>
                          <td>{{ item.message }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="pink darken-1"
              text
              @click="close"
            >
              Đóng lại
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  <script>
    export default {
      props: {
        showDialog: {
          type: Boolean,
          default: false
        },
        cosoId: {
          type: Number,
        },
      },
  
      data () {
        return {
          dialog: false,
          errors_exist: false,
          errors: [],
          item: {
  
          },
          expanded: ['Donut'],
          singleExpand: false,
          headers: [
            { text: 'Tên liên hệ', value: 'name' },
            { text: 'Email', value: 'email' },
            { text: 'Số điện thoại', value: 'phone' },
            { text: 'Thời gian', value: 'created_at' }
          ],
          items: [],
        }
      },
  
      computed: {
        
      },
  
      mounted() {
        this.dialog = this.showDialog
      },
  
      watch: {
        showDialog() {
          if (this.showDialog) {
            this.dialog = true
            axios.get("api/v1/user-get-message/" + this.cosoId)
              .then(response => {
                this.items = response.data
              })
              .catch(function (error) {
               console.log(error);
              });
          }
        }
      },
  
      methods: {
        close(item) {
          this.dialog = false;
          this.$emit('cancelled')
        },
        // clicked(value) {
        //   this.expanded.push(value)
        // }
      }
    }
  </script>